<template>
  <li
    class="breadcrumb breadcrumb__item"
    itemprop="itemListElement"
    itemscope
    itemtype="http://schema.org/ListItem"
    @click.prevent="handleClick"
  >
    <a
      v-if="isLink"
      class="breadcrumb__link"
      :class="`breadcrumb__link--${linkColor}`"
      :href="breadcrumbLink"
      itemtype="http://schema.org/Thing"
      itemprop="item"
    >
      <span class="breadcrumb__name" itemprop="name">{{ breadcrumbName }}</span>
    </a>
    <span v-else class="breadcrumb__name" itemprop="name">{{ breadcrumbName }}</span>
    <meta itemprop="position" content="1" />
    <span v-if="isSeparatorVisible" class="breadcrumb__separator">
      <IconArrowDown
        v-if="separatorType === BREADCRUMB_STYLE.separator.arrow"
        class="breadcrumb__separator-icon"
      />
      <span class="breadcrumb__separator-dot" v-else>•</span>
    </span>
  </li>
</template>

<script>
import { mapState } from 'vuex'
import IconArrowDown from '@/components/_icons/IconArrowDown.svg'
import {
  notifyExternalServices,
  ACTIONS,
} from '@/services/external-communication/external-communication'
import { handleFilterToFilterPageNavigation } from '@/components/Navigation/navigation-helpers'

export const BREADCRUMB_STYLE = {
  color: {
    black: 'black',
    grey: 'grey',
  },
  separator: {
    arrow: 'arrow',
    dot: 'dot',
  },
}

export default {
  name: 'Breadcrumb',
  components: { IconArrowDown },
  props: {
    breadcrumbLink: {
      type: String,
      required: true,
    },

    breadcrumbName: {
      type: String,
      required: true,
    },

    isSeparatorVisible: {
      type: Boolean,
      default: true,
    },

    separatorType: {
      type: String,
      default: BREADCRUMB_STYLE.separator.arrow,
      validator: value => Object.values(BREADCRUMB_STYLE.separator).includes(value),
    },

    isLink: {
      type: Boolean,
      default: true,
    },

    linkColor: {
      type: String,
      default: BREADCRUMB_STYLE.color.black,
      validator: value => Object.values(BREADCRUMB_STYLE.color).includes(value),
    },
  },

  data() {
    return {
      BREADCRUMB_STYLE,
    }
  },

  computed: {
    ...mapState('page', ['locale']),
  },

  methods: {
    handleClick() {
      if (!this.isLink) return
      handleFilterToFilterPageNavigation(this.breadcrumbLink)

      notifyExternalServices({
        action: ACTIONS.navigation,
        details: { action: 'breadcrumb', label: this.breadcrumbLink.split(this.locale)[1] || '/' },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.breadcrumb {
  &__item {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }

  &__link {
    color: $color-grey-dark-2;

    &:hover {
      color: $color-grey-mid-3;
    }

    &--grey {
      color: $c-grey-mid-3;

      &:hover {
        color: $c-grey-dark-1;
      }
    }
  }

  &__name {
    font-size: 10px;
    font-weight: bold;
    letter-spacing: 0.2em;
    line-height: 1;
    text-transform: uppercase;
    transition: color $transition-time-fast;

    @media ($mq-larger) {
      font-size: 11px;
    }
  }

  &__separator {
    flex: 0 0 auto;
  }

  &__separator-icon {
    display: block;
    width: 26px;
    height: 26px;
    transform: rotate(-90deg);

    @media ($mq-larger) {
      width: 29px;
      height: 29px;
    }

    /deep/ path {
      stroke: $color-grey-mid-1;
    }
  }

  &__separator-dot {
    color: $color-grey-mid-1;
    font-size: 11px;
    margin: 0 10px;
  }
}
</style>
